import React from 'react';

function sanitizeReplacements(replacements) {
    return Object.keys(replacements).reduce(
        (o, id) => ({
            ...o,
            [`[${id}]`]: replacements[id],
        }),
        {}
    );
}

function isJsx(replacement) {
    return replacement.$$typeof;
}

export default function templateReplacer(text, replacements) {
    if (typeof text === 'string' && replacements) {
        let hasJsx = false;
        const sanitizedReplacements = sanitizeReplacements(replacements);

        const regexStrong = RegExp('\\[__STRONG(\\d*)\\]');
        const regexI = RegExp('\\[__I(\\d*)\\]');

        const parts = text.split(/(\[\w+\])/).map((part, i) => {
            try {
                if (part === '[__BUTTON]') {
                    // BB macro
                    hasJsx = true;
                    return {
                        ...sanitizedReplacements[part](sanitizedReplacements['[__BUTTON_CONTENT]']),
                        key: i,
                    };
                } else if (part === '[__LINK]') {
                    // BB macro
                    hasJsx = true;
                    return {
                        ...sanitizedReplacements[part](sanitizedReplacements['[__LINK_CONTENT]']),
                        key: i,
                    };
                } else if (regexI.test(part)) {
                    // BB macro
                    const index: string = regexI.exec(part)?.[1] || '';
                    const replacement: string = '[__I_CONTENT' + index + ']';

                    hasJsx = true;
                    return {
                        ...sanitizedReplacements[part](templateReplacer(sanitizedReplacements[replacement], replacements)),
                        key: i,
                    };
                } else if (regexStrong.test(part)) {
                    // BB macro
                    const index: string = regexStrong.exec(part)?.[1] || '';
                    const replacement: string = '[__STRONG_CONTENT' + index + ']';

                    hasJsx = true;
                    return {
                        ...sanitizedReplacements[part](templateReplacer(sanitizedReplacements[replacement], replacements)),
                        key: i,
                    };
                } else if (part === '[BR]') {
                    // BB macro
                    hasJsx = true;
                    const defaultReplacer = () => <br />;
                    const replacer: any = sanitizedReplacements[part] || defaultReplacer;
                    return {
                        ...replacer(sanitizedReplacements['[BR]']),
                        key: i,
                    };
                } else if (sanitizedReplacements[part] !== undefined && sanitizedReplacements[part] !== null) {
                    if (isJsx(sanitizedReplacements[part])) {
                        hasJsx = true;

                        return {
                            ...sanitizedReplacements[part],
                            key: i,
                        };
                    }

                    return sanitizedReplacements[part];
                }
            } catch (e) {}

            return part;
        });

        return hasJsx ? parts : parts.join('');
    }

    return text;
}
